const RelatorioFilas = () =>
  import(/* webpackChunkName: "group-callcenter-relatorios-fila" */ '../_views/RelatoriosFilas')

import { permissionsRelatorioFila } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'filas',
    meta: { requiresAuth: true, permissions: [...permissionsRelatorioFila] },
    component: RelatorioFilas,
    name: 'RelatorioFilas',
  },
]
